<template>
    <!-- <page-header></page-header> -->
    <div class="container ">
        <div class="navBar">
            <div class="avtor yx-center">
                <div class="img">
                    <img src="../../assets/img/defaulteActor.png" alt="">
                </div>
                <div class="font-size20 userName">
                    {{userName}}
                </div>
            </div>

            <div class="jf outBtns xy-center">
                <div class="exitBtn xy-center" @click="loginOut">退出</div>
                <div class="editorBtn c-256CF4 xy-center" @click="EditPwd">修改密码</div>
            </div>

            <div class="navsbtn">
                <div class="navItem"
                     v-for="item in profileRoutes"
                     :class="{'avtive ': $route.path===item.Path}"
                     :key="item.Id"
                     @click.stop="routeSkip(item)">
                    {{item.Name}}
                </div>
            </div>

        </div>

        <!--修改密码弹框-->
        <el-dialog title="修改密码" :visible.sync="pwdVisible" :destroy-on-close="true" :close-on-click-modal="false"
            @close="CloseDialog" width="500px">

            <div class="dialog-div">
                <p class="dialog-div-p">原密码：</p>
                <div>
                    <el-input class="dialog-text" v-model="oldPwd" show-password placeholder="请输入原密码..."></el-input>
                </div>
            </div>
            <div class="dialog-div">
                <p class="dialog-div-p">新密码：</p>
                <div>
                    <el-input class="dialog-text" v-model="newPwd" prop="newPwd" :minlength="6" :maxlength="18"
                        show-password placeholder="请填写新密码..." @change="PwdValidate"></el-input>
                </div>
            </div>
            <div class="dialog-div">
                <p class="dialog-div-p">确认新密码：</p>
                <div>
                    <el-input class="dialog-text" v-model="newPwdTwo" :minlength="6" :maxlength="18" show-password
                        placeholder="请确认新密码..." @change="PwdValidate"></el-input>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="CloseDialog">取消</el-button>
                <el-button type="primary" size="mini" @click="UpdatePwd">确定</el-button>
            </span>
        </el-dialog>
        <!--修改密码弹框-->

    </div>
</template>

<script>
import {
    UserInfo,
    UpdatePwdForOldPwd,
    loginOut
} from "@/api/user";
import { sm2Encrypt } from "@/utils/sm2";
export default {
    components: {},
    created() {
        this.getUserInfo()
        if (this.$store.state.isLoadProfileRoutes === false) {
            this.$store.dispatch("getPersonCenter")
        }
    },
    data() {
        return {
            pwdVisible: false,
            oldPwd: "",
            newPwd: "",
            newPwdTwo: "",
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        userName() {
            return this.userInfo.RealName ? this.userInfo.RealName : this.userInfo.Tel
        },
        profileRoutes () {
            return this.$store.state.profileRoutes
        }
    },
    methods: {
        routeSkip(item) {
            const path = String(item.Path)
            const realPath = path.startsWith("/") ? path : "/" + path
            this.$router.push(`..${realPath}`)
        },
        EditPwd() {
            this.pwdVisible = true
        },
        CloseDialog() {
            this.pwdVisible = false
            this.oldPwd = ""
            this.newPwd = ""
            this.newPwdTwo = ""
        },
        // 获取用户信息
        async getUserInfo() {
            const {
                data
            } = await UserInfo();
            if (data.code === 100) {
                this.$store.commit("setUserInfo", data.data)
            }
        },
        // 获取路由
        // 密码验证
        PwdValidate(val) {
            if (typeof val === "string" && (val.length < 6 || val.length > 18)) {
                return this.$message.error("密码长度在6~18位之间")
            }
            if (!/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]/.test(val)) {
                return this.$message({
                    type: "error",
                    message: `密码包含数字、大小写字母、特殊字符至少两种`
                });
            }
        },
        // 密码验证（提交时验证）
        PwdValidateForSubmit(value) {
            if (value) {
                /* 大小写字母+数字+特殊符号
                      /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/
                    */
                var firstValidate = /^.*(?=.{6,18})(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(value);
                var sencendValidate = /^.*(?=.{6,18})(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*? ]).*$/.test(value);
                if (!firstValidate && !sencendValidate) {
                    // this.$message({ message: "新密码需包含字母、数字、特殊字符中至少两种！", type: "error" })
                    return false
                }
                return true
            }
        },
        // 修改密码
        async UpdatePwd() {
            if (!this.oldPwd) {
                this.$message({
                    message: "请输入原密码！",
                    type: "error"
                })
                return
            }

            if (!this.newPwd) {
                this.$message({
                    message: "请填写新密码！",
                    type: "error"
                })
                return
            }

            if (!this.newPwdTwo) {
                this.$message({
                    message: "请确认新密码！",
                    type: "error"
                })
                return
            }

            if (this.newPwd !== this.newPwdTwo) {
                this.$message({
                    message: "两次新密码输入不一致，请确认！",
                    type: "error"
                })
                return
            }
            const val = this.newPwdTwo
            if (typeof val === "string" && (val.length < 6 || val.length > 18)) {
                return this.$message.error("密码长度在6~18位之间")
            }
            if (!/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]/.test(this.newPwdTwo)) {
                return this.$message({
                    type: "error",
                    message: `密码包含数字、大小写字母、特殊字符至少两种`
                });
            }
            try {
                const {
                    data
                } = await UpdatePwdForOldPwd({
                    oldpass: sm2Encrypt(this.oldPwd),
                    newpass: sm2Encrypt(this.newPwd)
                });
                if (data.code === 100) {
                    this.$message({
                        message: "更新成功！",
                        type: "success"
                    });
                    this.CloseDialog()
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    })
                }
            } catch (err) {
                this.$message({
                    message: "发生异常！",
                    type: "error"
                })
            }
        },
        // 退出
        loginOut() {
            this.$confirm("是否确认退出医学培训考试服务平台?", "提示", {
                confirmButtonText: "确认退出",
                cancelButtonText: "我再想想",
                type: "warning"
            }).then(() => {
                this.goOut()
            }).catch(() => {

            });
        },
        async goOut() {
            try {
                const { data } = await loginOut()
                this.$store.commit("setUser", null)
                this.$store.commit("setUserInfo", null)
                window.location.href = window.location.pathname
            } catch (err) {
                console.log(error);
            }
        }
    }
}

</script>

<style lang="less" scoped>
    .container {
        .navBar {
            box-sizing: border-box;
            width: 220px;
            height: 830px;
            background: #FFFFFF;
            border-radius: 16px;

            .avtor {
                .img {
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    background-color: pink;
                    margin: 30px 0;

                    img {
                        width: 100%;
                    }
                }

                .userName {
                    height: 50px;
                }
            }

            .outBtns {
                margin: 30px 0 40px 0;

                .exitBtn {
                    width: 70px;
                    height: 32px;
                    background: #EDF3FF;
                    border-radius: 4px;
                }

                .editorBtn {
                    margin-left: 15px;
                    width: 90px;
                    height: 32px;
                    background: #EDF3FF;
                    border-radius: 4px;
                }
            }

            .navsbtn {
                .navItem {
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    font-size: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }

                .avtive {
                    background: #F4F5F6;
                    color: #256CF4;
                }
            }
        }

        .rightContent {
            width: 950px;
            height: 20px;
            height: 830px;
            background: #FFFFFF;
            border-radius: 16px;
        }

        .xy-center {
            cursor: pointer;
        }

        ::v-deep .el-dialog__body {
            border-top: 1px solid #dcdfe6;
        }

        ::v-deep .el-dialog__footer {
            height: 50px;
            border-top: 1px solid #dcdfe6;
            margin-top: 20px;
        }

        .dialog-div {
            padding: 20px 0 20px 0;

            .dialog-div-p {
                width: 120px;
                text-align: right;
                float: left;
            }

            ;

            .dialog-text {
                width: 300px;
                height: 30px;
            }

        }

    }

</style>
